fx.ns("desktop.common.screens", class Splash extends desktop.common.screens.BaseSplash{
    
	constructor()
	{
		super();

		this.showEffect = "hslideout";
		this.hideEffect = "hslidein";

		this.destroyOnSwitch = true;
	}

	onReady()
	{
		super.onReady();

        if (fx.get("mode") == "creating" || fx.get("mode") == "creating-ia")
            this.data.create();
        else
            this.data.load();

        if (fx.get("previewMode"))
			this.title = fx.text("Je vérifie votre création..");
		else
		{
			let message = shared.SplashContent.randomMessage(fx.get("mode"));
			this.title = fx.text(message.title);
			this.subtitle = fx.text(message.subtitle);
		}
	}

	onDataEvent(event)
	{
        if (event.type == "creation-loaded")
        {
            if (fx.get("previewMode"))
            {
                if (fx.get("app") == "poster" || fx.get("app") == "print")
                    this.data.event("next-step");
                else
                if (this.data.report().failed)
                    this.data.event("next-step", null, this.getDelay(1500));
                else
                    // a book goes through the order flow : the format / cover screens it never
                    // had are proposed before the cart (see BookMain.startCreationChoices)
                    this.data.event(fx.get("app") == "book" ? "order-confirmed" : "navigate-order");
            }
            else
                this.data.event("next-step", null, this.getDelay(500));
        }
			
		if (event.type == "creation-created")
			this.data.event("next-step", null, this.getDelay(1500));
	}



});

	